<template>
  <tr>
    <th class="c-text--en c-text--center">
      {{ item.date | dateText('YYYY.MM.DD') }}
    </th>
    <td>
      {{ item.name }}
    </td>
    <td class="c-text--center">
      <div class="c-alertPos">
        <Button radius variant="delete" @click="remove">
          <Tooltip variant="btn">
            絞り込み条件を削除
          </Tooltip>
        </Button>
      </div>
    </td>
  </tr>
</template>

<script>
import Button from '@/components/Button';
import Tooltip from '@/components/Tooltip';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    Button,
    Tooltip
  },

  methods: {
    remove() {
      this.$emit('delete', this.item.id);
    }
  }
};
</script>
